import type { WritableDeep } from 'type-fest';

import { ensureDefined } from '@e-socna/utils';

import type { DocumentEditorCmp_RecursiveSection } from '../fragments/recursive-section.fragment';

export const getDeepSection = <
  C extends
    | DocumentEditorCmp_RecursiveSection
    | WritableDeep<DocumentEditorCmp_RecursiveSection>,
>(
  content: Readonly<C>,
  path?: readonly number[],
): C => {
  if (!path?.length) {
    return content;
  }

  let result = content;

  path.forEach((level) => {
    const { pickedSubSection } = ensureDefined({
      pickedSubSection: result.subSections[level],
    });

    result = pickedSubSection as C;
  });

  return result;
};
